import api from "./api";

let csrfInitialized = false;
let csrfInitPromise: Promise<void> | null = null;

/**
 * Inicializa o token CSRF fazendo uma chamada para o endpoint específico
 * Esta função deve ser chamada no início da aplicação
 * Implements singleton pattern to prevent multiple initialization attempts
 */
export const initializeCSRF = async (): Promise<void> => {
	if (csrfInitialized) {
		return;
	}

	if (csrfInitPromise) {
		return csrfInitPromise;
	}

	csrfInitPromise = (async () => {
		try {
			await api.get("/csrf-token/");
			csrfInitialized = true;
		} catch (error) {
			if (process.env.NODE_ENV === "development") {
				console.warn(
					"CSRF token initialization failed - backend may not be running"
				);
			}
		} finally {
			csrfInitPromise = null;
		}
	})();

	return csrfInitPromise;
};

export default initializeCSRF;
